export default __webpack_public_path__ + "static/media/addGroup.00727b8c.svg";